module.exports = __webpack_public_path__ + "static/media/MusicDetailsScreen_elGoogleQRcode_1025211.1486fd50.jpg";